


































import { Component, Vue, Prop } from 'vue-property-decorator';
import Modal from '@/components/common/Modal.vue';
import SignupNew from '@/components/common/SignupNew.vue';
import TitleContainer from '@/components/common/TitleContainer.vue';
import Signin from '@/components/common/Signin.vue';

@Component({
  components: {
    Modal,
    SignupNew,
    TitleContainer,
    Signin,
  },
})
export default class ModalRegister2 extends Vue {
  @Prop()
  showRegister!: boolean;

  @Prop()
  closeRegister!: () => void;

  isSignup = true;

  get title() {
    return this.isSignup
      ? 'Join Program Affiliate 🥳'
      : 'Join Program Affiliate 🥳';
  }

  get description() {
    return this.isSignup
      ? 'Daftar akaun anda dahulu sebelum join Program Affiliate Mysoalan. Kami memerlukan sedikit maklumat tentang anda untuk bermula.'
      : 'Sign in ke akaun anda dahulu sebelum join Program Affiliate Mysoalan.';
  }

  get width() {
    return this.isSignup ? '700px' : '700px';
  }

  toggleForm() {
    this.isSignup = !this.isSignup;
  }

  forgotPasswordClick() {
    this.$router.push({
      path: '/amnesia',
    });
  }
}
